import { ArrowRight } from "lucide-react";

const VARIANTS = {
  dark: "bg-ink text-bone hover:bg-teal",
  light: "bg-bone text-ink hover:bg-teal hover:text-bone",
  teal: "bg-teal text-bone hover:bg-ink",
};

export const CTA = ({ children, onClick, variant = "dark", className = "", testId, type = "button", disabled }) => (
  <button
    type={type}
    onClick={onClick}
    disabled={disabled}
    data-testid={testId}
    className={`group inline-flex items-center justify-between gap-6 font-display font-medium text-sm sm:text-base tracking-[-0.005em] px-6 py-4 transition-colors duration-300 disabled:opacity-60 ${VARIANTS[variant]} ${className}`}
  >
    <span>{children}</span>
    <ArrowRight className="h-4 w-4 shrink-0 transition-transform duration-300 group-hover:translate-x-1" />
  </button>
);
